import FormField from 'components/form-field/form-field';
import { CountryCode } from 'modules/company/types/company.type';
import React, { FunctionComponent } from 'react';

type Props = {
  isDisabled: boolean;
  helpText?: React.ReactNode;
};

export const CountryCodeField: FunctionComponent<Props> = ({
  isDisabled,
  helpText,
}) => {
  return (
    <FormField
      type="radio"
      name="countryCode"
      disabled={isDisabled}
      options={[
        {
          label: 'France',
          value: CountryCode.FR,
          key: 'fr',
        },
        {
          label: 'Belgique',
          value: CountryCode.BE,
          key: 'be',
        },
      ]}
      label="Pays"
      helpText={helpText}
    />
  );
};
